<template>
  <v-card color="transparent" flat class="videos-card rounded-0 h-100" :to="to">
    <div class="videos-card-img">
      <img class="d-block" width="100%" :src="img" />
      <div class="icon-fade">
        <v-icon color="white" size="35" class="icon"> fas fa-play</v-icon>
      </div>
    </div>
    <div
      class="
        videos-card-title
        text-h6 text-md-h5 text-center
        d-flex
        align-center
        justify-center
        py-3 py-md-4
      "
    >
      <span class="font-barlow line-clamp">
        {{ title }}
      </span>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.line-clamp {
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.videos-card {
  &:hover {
    .videos-card-title {
      color: var(--v-secondary-base) !important;
    }
    .icon {
      opacity: 1 !important;
    }
  }
  &-title {
    transition: all 0.2s ease !important;
  }
  &-img {
    position: relative;
    img {
      aspect-ratio: 16/9;
      object-fit: cover;
    }
    .icon-fade {
      position: absolute;
      inset: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #00000057;
      .icon {
        opacity: 0.4;
      }
    }
  }
}
</style>
